import React from 'react';
import AssessmentRunner from '../components/Assessments/AssessmentRunner';
import { talentAssessmentsAPI } from '../services/api';
import { findGlossaryMatches } from '../config/bigFiveQuestionGlossary';

/**
 * Big Five Profile — assessment take page.
 *
 * Thin wrapper around the shared `AssessmentRunner` (the original
 * implementation of this page was extracted there when DISC was added).
 */
const BIG_FIVE_RUNNER_CONFIG = {
  brandLabel: 'Big Five Profile',
  prompt: 'How accurate is this statement about you?',
  submitLabel: 'Submit Big Five Profile',
  successToast: "All done! Your Big Five Profile is ready.",
  homeRoute: '/self-service/big-five',
  resultRoute: '/self-service/big-five/result',
  api: {
    getBundle: talentAssessmentsAPI.getBigFiveBundle,
    getSession: talentAssessmentsAPI.getBigFiveSession,
    saveResponse: talentAssessmentsAPI.saveBigFiveResponse,
    submitSession: talentAssessmentsAPI.submitBigFiveSession,
  },
  findGlossaryMatches,
};

const SelfServiceBigFiveTake = () => (
  <AssessmentRunner config={BIG_FIVE_RUNNER_CONFIG} />
);

export default SelfServiceBigFiveTake;
